import ApiService from "./ApiService";

const EMPTY_QUOTA = {
    monthlyLimit: 50,
    monthlyUsed: 0,
    monthlyLeft: 50,
    extraPdfCredits: 0,
    subscribed: false,
    allowed: false,
    reason: "missing",
    consumed: false,
};

const TutorPdfService = {
    fetchQuota: async () => {
        const data = await ApiService.getData("/v1/tutor/pdf/quota");
        return { ...EMPTY_QUOTA, ...(data || {}) };
    },

    consumeExport: async () => {
        const data = await ApiService.postData("/v1/tutor/pdf/export", {});
        return { ...EMPTY_QUOTA, ...(data || {}) };
    },
};

export default TutorPdfService;
